import DOMPurify from "dompurify";

/**
 * Sanitize untrusted HTML (e.g. Shopify CMS fields) before rendering with
 * dangerouslySetInnerHTML. Strips <script>, event handlers, and other
 * vectors that could execute arbitrary JS in the user's browser.
 */
export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return "";
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
